// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"850px","play-icon":"playIcon-module__play-icon___1BcyB","playIcon":"playIcon-module__play-icon___1BcyB","icon":"playIcon-module__icon___1OzMR"};